// extracted by mini-css-extract-plugin
module.exports = {"header":"RecentlyDeceased_header__uKl8u","header__item":"RecentlyDeceased_header__item__Zl8QC","recent":"RecentlyDeceased_recent__Sgu8Q"};